/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Vehicles_ManageInputs */

const vi_nav_vehicles_manage = /** @type {(inputs: Nav_Vehicles_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý xe`)
};

/**

* @param {Nav_Vehicles_ManageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_vehicles_manage = /** @type {((inputs?: Nav_Vehicles_ManageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Vehicles_ManageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_vehicles_manage(inputs)
});